import React from 'react'
// libs
import { useSelector } from 'react-redux'
import { formValueSelector } from 'redux-form'
// components
import { ReduxEntitySelect, ReduxSelect, ReduxSwitch } from 'components/FormElements'
// constants
import { DATA_SOURCE_OPTIONS } from 'constants/objects'
import { SELECT_GROUP_LABELS } from 'constants/forms'
// graphql
import { OBJECT_SECURITIES_QUERY } from 'graphql/objectSecurity/queries'
import { RISK_TEMPLATE_SELECT_QUERY } from 'graphql/risk/queries'
// types
import { Forms } from 'constants/forms'
import { IOption } from 'components/FormElements/Select'
import { ENTITIES } from 'constants/entities'
import { FieldSource, IField } from 'types/graphql'
// utils
import { required } from 'utils/validators'
import { objectSecurityProps, riskTemplatesProps } from 'components/FormElements/ReduxForm/ReduxEntitySelect/utils'

interface Props {
  isForm: boolean
  property: IField
}

const OBJECT_SECURITIES_QUERY_FILTER = {
  filter: {
    objectEntityApiName: 'risks'
  }
}

export const USER_DETAILS_FIELDS_OPTIONS = [
  { label: 'E Number', value: 'eNumber' },
  { label: 'Worksite Name', value: 'worksiteName' },
  { label: 'Worksite Address', value: 'worksiteAddress' },
  { label: 'Phone', value: 'phone' },
  { label: 'Email', value: 'email' }
]

const selector = formValueSelector(Forms.PROPERTY_EDIT_FORM)

const securitySources = [FieldSource.Users, FieldSource.Positions]

const LookupSettings: React.FC<Props> = ({ isForm, property }) => {
  const source = useSelector((state) => selector(state, 'source')) || []
  const showUserDetails = useSelector((state) => selector(state, 'showUserDetails')) || []

  const showDetailsSwitch = isForm && source.some(({ value }) => FieldSource.Users === value)
  const showSecurityFields = isForm && source.some(({ value }) => securitySources.includes(value))

  const prepareOptions = (data: IOption[]) => {
    return [
      { label: SELECT_GROUP_LABELS.SOURCES, options: DATA_SOURCE_OPTIONS },
      { label: SELECT_GROUP_LABELS.ANOTHER_FORM, options: data.map((item) => ({ ...item, entity: ENTITIES.RISK })) }
    ]
  }

  return (
    <>
      <ReduxSwitch disabled={property.standard} name='multiple' label='Allow Multiple Selections' reverse />
      <ReduxEntitySelect
        isMultiple
        name='source'
        label='Data Source'
        menuPlacement='top'
        validate={required}
        prepareOptions={prepareOptions}
        query={RISK_TEMPLATE_SELECT_QUERY}
        {...riskTemplatesProps}
      />
      {showDetailsSwitch && <ReduxSwitch name='showUserDetails' label='Show User Details' reverse />}
      {showUserDetails && (
        <ReduxSelect
          isMultiple
          label='User Fields'
          name='visibleUserDetailsFields'
          options={USER_DETAILS_FIELDS_OPTIONS}
        />
      )}
      {showSecurityFields && (
        <ReduxEntitySelect
          isClearable
          name='objectSecurity'
          query={OBJECT_SECURITIES_QUERY}
          label='Default Object Security Role'
          variables={OBJECT_SECURITIES_QUERY_FILTER}
          {...objectSecurityProps}
        />
      )}
    </>
  )
}

export default LookupSettings
